import { produce } from 'immer';

import { useStore } from '../store';

export const setActiveCommentId = (id: string | null) => {
  useStore.setState(state =>
    produce(state, draft => {
      draft.activeComment = id;
    })
  );
};
